var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-steps"},_vm._l((_vm.numberOfSteps),function(step){return _c('div',{key:step,staticClass:"form-steps__step",class:[
      { active: step === _vm.activeStep },
      { 'not-passed': step > _vm.activeStep }
    ]},[_c('div',{staticClass:"form-steps__step--dot"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }